export default __webpack_public_path__ + "static/media/Screenshot (21).1734a5a3.png";